export const en = {
  no: 'No',
  yes: 'Yes',
  total: 'Total',
  userNotFound: 'User not found',
  invalidCredentials: 'Invalid credentials',
  badOldPassword: 'Wrong old password',
  somethingWentWrong: 'Something went wrong',
  sww: 'Something went wrong',
  tooReqError: 'Too many requests, try again later',
  fieldRequired: 'Required field',
  invalidEmail: 'Invalid e-mail',
  passwordTooShort: 'Password must include at least {0} characters',
  login: 'Login',
  signIn: 'Sign in',
  email: 'E-mail',
  password: 'Password',
  dashboard: 'Dashboard',
  users: 'Users',
  customers: 'Customers',
  managers: 'Managers',
  totalDevices: 'Total installations',
  onlineDevices: 'Online installations',
  devicesOnAlarm: 'Installations on alarm',
  deviceStatus: 'Status of installations',
  search: 'Search',
  mac: 'MAC',
  model: 'Model',
  registrationNumber: 'Serial number',
  alarms: 'Alarms',
  warnings: 'Warnings',
  status: 'Status',
  lastConnection: 'Last connection',
  details: 'Details',
  summary: 'Summary',
  viewAll: 'View all',
  customersList: 'List of customers',
  managerList: 'List of managers',
  id: 'ID',
  nameSurname: 'Name and surname',
  city: 'Town',
  role: 'Role',
  notAuthorized: 'Not authorized',
  confirm: 'Confirm',
  disconnectQuestion: 'Do you want to logout?',
  logout: 'Logout',
  menu: 'Menu',
  online: 'Online',
  offline: 'Offline',
  actives: 'Active',
  user: 'User',
  admin: 'Administrator',
  technician: 'Technician',
  alarmsHistory: 'Alarm history',
  date: 'Date',
  dates: 'Dates',
  name: 'Name',
  type: 'Type',
  alarm: 'Alarm',
  warning: 'Warning',
  forgetPasswordQuestion: 'Password forgotten?',
  signUp: 'Register',
  registration: 'Registration',
  attention: 'Warning',
  ok: 'OK',
  acceptDataPrivacyAgreementWarn: 'You must consent to your data processing',
  acceptDataMarketingAgreementWarn: 'Select an option for data use for marketing purpose',
  passwordMismatch: 'Passwords do not match',
  repeatPassword: 'Repeat password',
  telephone: 'Telephone',
  nation: 'Country',
  company: 'Platform',
  dataAgreement:
    'Flagging the box you accept the privacy policy terms as per EU Directive 679/2016 and declare that you are of legal age',
  agree: 'I agree',
  notAgree: "I don't agree",
  marketingAgreement:
    'Flagging the box you accept the use of your personal data for marketing purpose by STEIEL',
  privacyTreatment: 'Privacy policy',
  verifyEmail: 'Verify e-mail',
  emailSentToYourEmail: 'A verification e-mail has been sent to:',
  emailNotReceivedQuestion: "You didn't receive the e-mail?",
  sendAgain: 'Send again',
  verificationEmailSent: 'Verification e-mail sent',
  lostPasswordQuestion: 'Do you forgot the password?',
  lostPasswordInstructions:
    'Enter the e-mail address to send the instructions for new password setting',
  resetPassword: 'Reset password',
  goBack: 'Return back',
  emailSentToYourAddress: 'An e-mail has be sent to your address',
  passwordChanged: 'Password modified',
  notice: 'Notice',
  changePassword: 'Change password',
  settings: 'Settings',
  add: 'Add',
  profile: 'Profile',
  security: 'Security',
  saveChanges: 'Save changes',
  profileSavedSuccessfully: 'Profile saved',
  dataSavedSuccessfully: 'Data saved',
  oldPassword: 'Old password',
  passwordChangedSuccessfully: 'Password changed',
  counterResettedSuccessfully: 'Counter reset',
  at: 'at',
  noDataFound: 'No data found',
  deviceManagement: 'Installation management',
  modulesManagement: 'Devices List',
  moduleName: 'Module',
  installationName: 'Installation',
  usersManagement: 'User management',
  version: 'Version',
  dateAndTime: 'Date/Time',
  place: 'Place',
  comeback: 'Return back',
  setup: 'Setup',
  default: 'Default',
  interface: 'Interface',
  temperature: 'Temperature',
  ph: 'pH',
  chlorine: 'Chlorine',
  totalChlorine: 'Total chlorine',
  freeChlorine: 'Free chlorine',
  combinedChlorine: 'Combined chlorine',
  table: 'Table',
  charts: 'Charts',
  setpoint: 'Setpoint',
  customizeMeasurements: 'Customize layout',
  active: 'Active',
  deactivated: 'Not active',
  minAcceptableValue: 'Min acceptable limit',
  maxAcceptableValue: 'Max acceptable limit',
  outputs: 'Outputs',
  inputs: 'Inputs',
  on: 'On',
  off: 'Off',
  value: 'Value',
  exportTable: 'Export table',
  exportAlarms: 'Export alarms',
  localDateTime: 'Date/Time (local)',
  notes: 'Notes',
  channel: 'Channel',
  description: 'Description',
  deviceDetails: 'Installation details',
  measure: 'Measurement',
  enable: 'Enable',
  unitOfMeasure: 'Measure unit',
  scaleStart: 'Scale start',
  bottomScale: 'Full scale',
  minAlarm: 'Min alarm',
  maxAlarm: 'Max alarm',
  minAcceptableLimit: 'Min acceptable limit',
  maxAcceptableLimit: 'Max acceptable limit',
  decimals: 'Decimals',
  selectWidget: 'Select Widget',
  notifications: 'Notifications',
  notificationsDelay: 'Notification delay (minutes)',
  recipientList: 'List of recipients',
  customizeNotification: 'Customize notification',
  apply: 'Apply',
  view: 'View',
  searchPlaceholder: 'Search ID, name, place',
  filter: 'Filter',
  withAlarm: 'Alarm',
  notWithAlarm: 'No alarm',
  cancel: 'Cancel',
  close: 'Close',
  deviceDefaultSettingsResetQuestion: 'Do you want to restore default settings?',
  samplingTime: 'Sampling time (min)',
  timeZone: 'Time zone',
  macAddress: 'MAC address',
  tool: 'Instrument',
  newCustomer: 'New user',
  newManager: 'New manager',
  locality: 'Place',
  notificationManagement: 'Notification management',
  manageNotifications: 'Manage notifications',
  sendEmail: 'Send e-mail',
  usersList: 'List of users',
  modifyCustomer: 'Modify user',
  modifyManager: 'Modify manager',
  newUser: 'New user',
  deleteUser: 'Delete user',
  notePlaceholder: 'Enter note',
  insertLogo: 'Enter logo',
  language: 'Language',
  file: 'File',
  create: 'Create',
  modify: 'Edit',
  update: 'Update',
  createNewCustomer: 'Create new user',
  createNewManager: 'Create new manager',
  viewer: 'Viewer',
  superTechnician: 'Installer',
  supertechnician: 'Installer',
  newDevice: 'New installation',
  createNewDevice: 'Create new installation',
  installer: 'Installer',
  newModule: 'New module',
  modules: 'Modules',
  numberOfDevices: 'No. Devices',
  modifyDevice: 'Modify installation',
  goToDevicePage: 'Go to Installation Status',
  searchByNamePlace: 'Search by name, place',
  searchByNameSurnameUsername: 'Search by name, surname, username ...',
  surname: 'Surname',
  username: 'Username',
  modifyUser: 'Modify user',
  confirmPassword: 'Confirm password',
  insertNote: 'Enter note',
  createNewUser: 'Create new user',
  customersManagement: 'User management',
  customer: 'User',
  manager: 'Manager',
  send: 'Send',
  modifyPassword: 'Change password',
  newPassword: 'New password',
  passwordRecoveryInstructions: 'Enter your e-mail address to receive the link for password change',
  userProfile: 'User profile',
  italian: 'Italian',
  english: 'English',
  currentPassword: 'Current password',
  new: 'New',
  deviceInterfaceChartTitle: 'SwimEx Cold Plunge Pool',
  deviceInterfaceChartMobileTip: 'Put the device horizontally for a better view of the chart',
  deviceInterfaceChartTip: 'Place the pointer on the chart to view data',
  dtBodyNoMatch: 'No data found',
  dtBodyTooltip: 'Sort',
  dtBodyColumnHeaderTooltip: 'Sort by',
  dtNextPage: 'Next page',
  dtPreviousPage: 'Previous page',
  dtRowsPerPage: 'Rows per page:',
  jumpToPage: 'Go to page:',
  dtDisplayRows: 'of',
  dtToolbarSearch: 'Search',
  dtToolbarDownloadCsv: 'Download CSV',
  dtToolbarPrint: 'Print',
  dtToolbarViewColumns: 'View columns',
  dtToolbarFilterTable: 'Filter table',
  dtFilterAll: 'All',
  dtFilterTitle: 'Filters',
  dtFilterReset: 'Reset',
  dtViewColumnsTitle: 'Show columns',
  dtViewColumnsTitleAria: 'Show/hide columns',
  dtSelectedRowsText: 'Selected rows',
  dtSelectedRowsDelete: 'Delete',
  dtSelectedRowsDeleteAria: 'Delete selected rows',
  success: 'Successful',
  recoveryPasswordEmailSent: 'E-mail sent for password recovery',
  french: 'French',
  noInterfaceConnected: 'No interface connected',
  hthInterfaceName: 'CYCL’EAU First',
  hthProInterfaceName: 'CYCL’EAU Pro',
  input_pHLvl: 'pH level',
  input_cl2Lvl: 'Chlorine level',
  input_lvl3: 'Level 3',
  input_flow: 'Flow',
  input_cadOff: 'CAD (Off)',
  output_out1: 'Out 1',
  output_out2: 'Out 2',
  output_alarm: 'Alarm relay',
  alarm_lowPHLvl: 'Low pH level',
  alarm_lowCl2Lvl: 'Low chlorine level',
  alarm_flow: 'Flow',
  alarm_onOffKey: 'ON/OFF key',
  alarm_inputCadOff: 'CAD Off input',
  alarm_maxPHDosage: 'Max pH dosage',
  alarm_maxCl2Dosage: 'Max chlorine dosage',
  alarm_startDelay: 'Start-up delay',
  alarm_pHMin: 'Min pH',
  alarm_phMax: 'Max pH',
  alarm_cl2Min: 'Min Cl',
  alarm_cl2Max: 'Max Cl',
  alarm_autoClean: 'Self-cleaning',
  noMeasurementFound: 'No measurement found',
  settingsSavedSuccessfully: 'Settings saved',
  parameters: 'Parameters',
  parameter: 'Parameter',
  noParametersFound: 'No parameter found',
  setpointPHParamDesc: 'Setpoint 1 (OUT_pH)',
  setpointCl2ParamDesc: 'Setpoint 2 (OUT_Cl)',
  minPHAlarmParamDesc: 'Alarm (alert) min pH',
  maxPHAlarmParamDesc: 'Allarme (avviso) max. pH',
  minFreeChlorineParamDesc: 'Alarm (alert) min chlorine',
  maxFreeChlorineParamDesc: 'Alarm (alert) max chlorine',
  maxCombChlorineParamDesc: 'Alarm (alert) max combined chlorine',
  settingTypePHParamDesc: 'OUT_pH Adjustment type',
  settingTypeCl2ParamDesc: 'OUT_Cl Adjustment type',
  hysteresisPHParamDesc: 'Hysteresis OUT_pH',
  hysteresisCl2ParamDesc: 'Hysteresis OUT_Cl2',
  sensePHParamDesc: 'pH sens',
  startDelayParamDesc: 'Start delay (sec)',
  flowDelayParamDesc: 'Delay after flow restoring (sec)',
  maxInjectionTimeParamDesc: 'Max injection time (min)',
  pHTankLvlParamDesc: 'Level of pH tank',
  chlorineTankLvlParamDesc: 'Level of chlorine tank',
  flowSensorParamDesc: 'Flow sensor',
  totalChlorineParamDesc: 'Total chlorine',
  languageParamDesc: 'Language',
  alarmRelayParamDesc: 'Alarm relay',
  serialLineParamDesc: 'Serial line',
  serialLineCommSpeedParamDesc: 'Communication speed of serial line',
  modbusCommAddrParamDesc: 'Modbus communication address',
  passwordParamDesc: 'Password',
  proportional: 'Proportional',
  onOff: 'On-Off',
  alkaline: 'Alkaline',
  acid: 'Acid',
  spanish: 'Spanish',
  ascii: 'Ascii',
  modbus: 'Modbus',
  min: 'min',
  max: 'max',
  onlineWithAlarm: 'Online with alarm',
  macAddressNotFound: 'MAC address not found',
  deviceFormModulesIncomplete:
    'For each module, fill in MAC, name, instrument and version (valid, non-empty values)',
  invalidCompanyValue: 'Invalid Platform',
  deleteDevice: 'Delete installation',
  deleteDeviceQuestion: 'Do you want to delete installation?',
  userCreatedSuccessfully: 'User created',
  deleteUserQuestion: 'Do you want to delete user {0}?',
  deviceCreatedSuccessfully: 'Installation created',
  noMeasurementsFoundOrEnabled: 'No measurement enabled or found',
  companyDomain: 'Platform domain',
  from: 'from',
  to: 'to',
  alarmsFixed: 'Solved alarms',
  badInputData: 'Wrong input data',
  changesCompleted: 'Changes completed',
  upload: 'Upload',
  invalidFileSize: 'Invalid file size',
  invalidFileType: 'Invalid file type',
  alarm_maxTimeK1: 'Max time K1',
  alarm_maxTimeK2: 'Max time K2',
  alarm_maxTimeK4: 'Max time K4',
  alarm_maxTimeK5: 'Max time K5',
  alarm_ignitionDelay: 'Start-up delay',
  alarm_pHStabilizer: 'pH stabilization',
  alarm_clock: 'Clock',
  alarm_zeroChlorine: 'Zero chlorine',
  alarm_redox: 'ORP',
  alarm_superchlorination: 'Superchlorination',
  alarm_notUsed1: 'Not used 1',
  alarm_notUsed2: 'Not used 2',
  alarm_notUsed3: 'Not used 3',
  alarm_notUsed4: 'Not used 4',
  alarm_richAssist: 'Service required',
  alarm_toolBlock: 'Instrument block',
  output_k1: 'K1',
  output_k2: 'K2',
  output_k3: 'K3',
  output_k4: 'K4',
  output_k5: 'K5',
  output_ev: 'EV',
  output_perist1: 'Perist1',
  output_perist2: 'Perist2',
  output_perist3: 'Perist3',
  output_mixer: 'Mixer 1',
  input_lvl1: 'Level 1',
  input_lvl2: 'Level 2',
  input_off: 'OFF input',
  input_imp: 'IMP input',
  P01MC14ParamDesc: 'Measurement associated to relay output K1',
  P02MC14ParamDesc: 'Output type of relay K1',
  P03MC14ParamDesc: '',
  P04MC14ParamDesc: '',
  P05MC14ParamDesc: '',
  P06MC14ParamDesc: '',
  P07MC14ParamDesc: 'Max dosing time alarm for K1 (h : min)',
  P08MC14ParamDesc: 'OFF conditions for relay K1',
  P09MC14ParamDesc: 'Measurement associated to relay output K2',
  P10MC14ParamDesc: 'Output type of relay K2',
  P11MC14ParamDesc: '',
  P12MC14ParamDesc: '',
  P13MC14ParamDesc: '',
  P14MC14ParamDesc: '',
  P15MC14ParamDesc: 'Max dosing time alarm for K2 (h : min)',
  P16MC14ParamDesc: 'OFF conditions for relay K2',
  P17MC14ParamDesc: '',
  P18MC14ParamDesc: '',
  P19MC14ParamDesc: '',
  P20MC14ParamDesc: '',
  P21MC14ParamDesc: '',
  P22MC14ParamDesc: '',
  P23MC14ParamDesc: '',
  P24MC14ParamDesc: '',
  P25MC14ParamDesc: '',
  P26MC14ParamDesc: '',
  P27MC14ParamDesc: '',
  P28MC14ParamDesc: '',
  P29MC14ParamDesc: '',
  P30MC14ParamDesc: '',
  P31MC14ParamDesc: '',
  P32MC14ParamDesc: '',
  P33MC14ParamDesc: '',
  P34MC14ParamDesc: '',
  P35MC14ParamDesc: '',
  P36MC14ParamDesc: '',
  P37MC14ParamDesc: '',
  P38MC14ParamDesc: '',
  P39MC14ParamDesc: '',
  P40MC14ParamDesc: '',
  P41MC14ParamDesc: '',
  P42MC14ParamDesc: '',
  P43MC14ParamDesc: '',
  P44MC14ParamDesc: '',
  P45MC14ParamDesc: '',
  P46MC14ParamDesc: '',
  P47MC14ParamDesc: '',
  P48MC14ParamDesc: '',
  P49MC14ParamDesc: '',
  P50MC14ParamDesc: '',
  P51MC14ParamDesc: '',
  P52MC14ParamDesc: '',
  P53MC14ParamDesc: '',
  P54MC14ParamDesc: '',
  P55MC14ParamDesc: '',
  P56MC14ParamDesc: '',
  P57MC14ParamDesc: '',
  P58MC14ParamDesc: '',
  P59MC14ParamDesc: '',
  P60MC14ParamDesc: '',
  P61MC14ParamDesc: '',
  P62MC14ParamDesc: '',
  P63MC14ParamDesc: '',
  P64MC14ParamDesc: '',
  P65MC14ParamDesc: '',
  P66MC14ParamDesc: '',
  P67MC14ParamDesc: '',
  P68MC14ParamDesc: '',
  P69MC14ParamDesc: '',
  P70MC14ParamDesc: '',
  P71MC14ParamDesc: '',
  P72MC14ParamDesc: '',
  P73MC14ParamDesc: '',
  P74MC14ParamDesc: '',
  P75MC14ParamDesc: '',
  P76MC14ParamDesc: '',
  P77MC14ParamDesc: '',
  P78MC14ParamDesc: '',
  P79MC14ParamDesc: '',
  P80MC14ParamDesc: '',
  P81MC14ParamDesc: '',
  P82MC14ParamDesc: '',
  P83MC14ParamDesc: '',
  P84MC14ParamDesc: '',
  P85MC14ParamDesc: '',
  P86MC14ParamDesc: '',
  P87MC14ParamDesc: '',
  P88MC14ParamDesc: '',
  P89MC14ParamDesc: '',
  P90MC14ParamDesc: '',
  P91MC14ParamDesc: '',
  P92MC14ParamDesc: '',
  P93MC14ParamDesc: '',
  P94MC14ParamDesc: '',
  notAvailable: 'Not available',
  disabled: 'Disabled',
  closingOverthresholds: 'Close when thresholds are exceeded',
  openingOverthreshold: 'Open when thresholds are exceeded',
  upward: 'Upwards',
  downward: 'Downwards',
  hourlyOperation: 'Timed operations',
  unknown: 'Unknown',
  mc14evoPHRxCle12TcInterfaceName: 'MC14 EVO pH/ORP/CLE12/T',
  mc14evoPHRxCacTcInterfaceName: 'MC14 EVO pH/ORP/CAC/T',
  mc14evo_4CanaliTcInterfaceName: 'MC14 EVO 4 channels + T',
  mco14_3SezCl2InterfaceName: 'MCO14 EVO 3 sections (Cl2)',
  mco14_5SezCl2ClTClCInterfaceName: 'MCO14 EVO 5 sections (Cl2 + ClT + ClC)',
  nsp161InterfaceName: 'NOVA NSP161',
  nsp161CMinInterfaceName: 'NOVA NSP161 s/min',
  nsp161MAInterfaceName: 'NOVA NSP161 mA',
  nsp162PHRxInterfaceName: 'NOVA NSP162 pH/ORP',
  nsp163ACle11_12InterfaceName: 'NOVA NSP163A CLE11/12',
  nsp163BCle16InterfaceName: 'NOVA NSP163B CLE16',
  pHRxTcInterfaceName: 'EF315 pH/ORP/T',
  pHClTcInterfaceName: 'EF315 pH/CL/T',
  pHCacTcInterfaceName: 'EF315 pH/CAC/T',
  channels: 'Channels',
  sectionMin: 'Sections',
  loggedInAs: 'Logged-in as',
  badRangeInput: 'Invalid values',
  open: 'Open',
  all: 'All',
  moduleComunicationTimeoutErrDesc: 'Check interface wiring and power supply',
  updateParamFailed: 'Parameter upgrading failed',
  saveChangesQuestion: 'Do you want to save changes?',
  secondaryParameters: 'Secondary parameters',
  P03MC14ParamDescOption1: 'Threshold to be reached by relay K1',
  P03MC14ParamDescOption2: 'Central value for K1 alarm',
  P03MC14ParamDescOption3: 'First activation time of K1',
  P04MC14ParamDescOption1: 'Hysteresis relay K1',
  P04MC14ParamDescOption2: 'Hysteresis above and below K1 threshold',
  P04MC14ParamDescOption3: 'First deactivation time of K1',
  P11MC14ParamDescOption1: 'Threshold to be reached by relay K2',
  P11MC14ParamDescOption2: 'Central value for K2 alarm',
  P11MC14ParamDescOption3: 'First activation time of K2',
  P12MC14ParamDescOption1: 'Hysteresis relay K2',
  P12MC14ParamDescOption2: 'Hysteresis above and below K2 threshold',
  P12MC14ParamDescOption3: 'First deactivation time of K2',
  P27MC14ParamDescOption1: 'Threshold to be reached by relay K4',
  P27MC14ParamDescOption2: 'Central value for K4 alarm',
  P27MC14ParamDescOption3: 'First activation time of K4',
  P28MC14ParamDescOption1: 'Hysteresis relay K4',
  P28MC14ParamDescOption2: 'Hysteresis above and below K4 threshold',
  P28MC14ParamDescOption3: 'First deactivation time of K4',
  alarm_lvl: 'Level',
  alarm_extcons: 'Ext. Cons.',
  alarm_stop: 'Stop',
  alarm_urOr: 'UR/OR',
  alarm_timer: 'Timer',
  alarm_maintenance: 'Maintenance',
  alarm_autoadesco: 'Self-priming',
  alarm_internalTemp: 'Internal temperature',
  alarm_maxDoseTime: 'Max dosing time',
  alarm_maxAccPulses: 'Max storable pulses',
  alarm_sampleWater: 'Sample water',
  alarm_clockKO: 'Clock KO',
  output_magnetStatus: 'Magnet status',
  output_relayAlarm: 'Status Relay',
  input_lvl: 'Level',
  input_extcons: 'Ext. Cons.',
  P01NSPParamDesc: 'Language',
  P02NSPParamDesc: '',
  P03NSPParamDesc: '',
  P04NSPParamDesc: '',
  P05NSPParamDesc: '',
  P06NSPParamDesc: '',
  P07NSPParamDesc: 'Max frequency',
  P08NSPParamDesc: '',
  P09NSPParamDesc: '',
  P10NSPParamDesc: '',
  P11NSPParamDesc: 'Setpoint',
  P12NSPParamDesc: 'Hysteresis / Proportional band',
  P13NSPParamDesc: '',
  P14NSPParamDesc: '',
  P15NSPParamDesc: '',
  P16NSPParamDesc: '',
  P17NSPParamDesc: '',
  P18NSPParamDesc: '',
  P19NSPParamDesc: '',
  P20NSPParamDesc: '',
  P21NSPParamDesc: '',
  P22NSPParamDesc: '',
  P23NSPParamDesc: '',
  P24NSPParamDesc: '',
  P25NSPParamDesc: '',
  P26NSPParamDesc: '',
  P27NSPParamDesc: '',
  P28NSPParamDesc: '',
  P29NSPParamDesc: '',
  P30NSPParamDesc: '',
  P31NSPParamDesc: '',
  P32NSPParamDesc: '',
  P33NSPParamDesc: '',
  P34NSPParamDesc: '',
  P35NSPParamDesc: '',
  P36NSPParamDesc: '',
  P37NSPParamDesc: '',
  P38NSPParamDesc: '',
  P39NSPParamDesc: '',
  P40NSPParamDesc: '',
  P41NSPParamDesc: '',
  P42NSPParamDesc: '',
  P43NSPParamDesc: '',
  P44NSPParamDesc: '',
  P45NSPParamDesc: '',
  P46NSPParamDesc: '',
  P47NSPParamDesc: '',
  P48NSPParamDesc: '',
  P49NSPParamDesc: '',
  P50NSPParamDesc: '',
  P51NSPParamDesc: '',
  P52NSPParamDesc: '',
  P53NSPParamDesc: '',
  P54NSPParamDesc: '',
  P55NSPParamDesc: '',
  P56NSPParamDesc: '',
  P57NSPParamDesc: '',
  P58NSPParamDesc: '',
  P59NSPParamDesc: '',
  P60NSPParamDesc: '',
  P61NSPParamDesc: '',
  P62NSPParamDesc: '',
  P63NSPParamDesc: '',
  P64NSPParamDesc: '',
  P65NSPParamDesc: '',
  P66NSPParamDesc: '',
  P67NSPParamDesc: '',
  P68NSPParamDesc: '',
  P69NSPParamDesc: '',
  P70NSPParamDesc: '',
  P71NSPParamDesc: '',
  P72NSPParamDesc: '',
  P73NSPParamDesc: '',
  P74NSPParamDesc: '',
  P75NSPParamDesc: '',
  P76NSPParamDesc: '',
  P77NSPParamDesc: '',
  P78NSPParamDesc: '',
  P79NSPParamDesc: '',
  P80NSPParamDesc: '',
  P81NSPParamDesc: '',
  P82NSPParamDesc: '',
  P83NSPParamDesc: '',
  P84NSPParamDesc: '',
  P85NSPParamDesc: '',
  P86NSPParamDesc: '',
  P87NSPParamDesc: '',
  P88NSPParamDesc: '',
  P89NSPParamDesc: '',
  P90NSPParamDesc: '',
  P91NSPParamDesc: '',
  P92NSPParamDesc: '',
  P93NSPParamDesc: '',
  P94NSPParamDesc: '',
  P95NSPParamDesc: '',
  alarm_lvl1: 'Level 1',
  alarm_lvl2: 'Level 2',
  alarm_maxDosageTimeOut1: 'Max dosage time Out 1',
  alarm_maxDosageTimeOut2: 'Max dosage time Out 2',
  alarm_urOrMeasure1: 'UR/OR Measure 1',
  alarm_urOrMeasure2: 'UR/OR Measure 2',
  alarm_maintenancePump1: 'Pump 1 maintenance',
  alarm_maintenancePump2: 'Pump 2 maintenance',
  alarm_recalibrateChlorineProbeAfter24h: 'Recalibrate chlorine probe after 24 hours',
  alarm_halvedSetpointForBadCalib: 'Setpoint halved',
  input_stop: 'Stop',
  input_ignitionDelay: 'Start-up delay',
  input_pHStabilizer: 'pH stabilization',
  input_maintenancePump1: 'Pump 1 maintenance',
  input_maintenancePump2: 'Pump 2 maintenance',
  input_recalibrateChlorineProbeAfter24h: 'Recalibrate chlorine probe after 24 hours',
  input_halvedSetpointForBadCalib: 'Setpoint halved',
  P01EFParamDesc: '',
  P02EFParamDesc: '',
  P03EFParamDesc: 'Setpoint (Out 1)',
  P04EFParamDesc: 'Hysteresis / Proportional band (Out 1)',
  P05EFParamDesc: 'Max frequency (Out 1)',
  P06EFParamDesc: '',
  P07EFParamDesc: '',
  P08EFParamDesc: '',
  P09EFParamDesc: '',
  P10EFParamDesc: 'Setpoint (Out 2)',
  P11EFParamDesc: 'Hysteresis / Proportional band (Out 2)',
  P12EFParamDesc: 'Max frequency (Out 2)',
  P13EFParamDesc: '',
  P14EFParamDesc: '',
  P15EFParamDesc: '',
  P16EFParamDesc: '',
  P17EFParamDesc: '',
  P18EFParamDesc: '',
  P19EFParamDesc: '',
  P20EFParamDesc: '',
  P21EFParamDesc: '',
  P22EFParamDesc: '',
  P23EFParamDesc: '',
  P24EFParamDesc: '',
  P25EFParamDesc: '',
  P26EFParamDesc: '',
  P27EFParamDesc: '',
  P28EFParamDesc: '',
  P29EFParamDesc: '',
  P30EFParamDesc: '',
  P31EFParamDesc: '',
  P32EFParamDesc: '',
  P33EFParamDesc: '',
  P34EFParamDesc: '',
  eventsLog: 'Events LOG',
  events: 'Events',
  alarm_new_stop: 'Instrument OFF',
  alarm_new_inputCadOff: 'OFF Input',
  alarm_new_flow: 'Flow Alarm',
  alarm_new_urOr: 'UR/OR Alarm',
  alarm_new_lowPHLvl: 'Min pH level alarm',
  alarm_new_lowCl2Lvl: 'Min Cl level alarm',
  alarm_new_maxPHDosage: 'Max pH level alarm',
  alarm_new_maxCl2Dosage: 'Max Cl level alarm',
  alarm_new_pHMin: 'Min pH alert',
  alarm_new_phMax: 'Max pH alert',
  alarm_new_cl2Min: 'Min Cl alert',
  alarm_new_cl2Max: 'Max Cl alert',
  alarm_new_clock: 'Timer',
  alarm_new_maxTimeK1: 'Max T K1 alarm',
  alarm_new_maxTimeK2: 'Max T K2 alarm',
  alarm_new_maxTimeK4: 'Max T K4 alarm',
  alarm_new_maxTimeK5: 'Max T K5 alarm',
  alarm_new_redox: 'ORP alarm',
  alarm_new_zeroChlorine: 'Zero Cl alarm',
  output_mixer2: 'Mixer 2',
  alarm_extConsensus: 'External Consent',
  alarm_lvl1MinAlarm: 'Min level 1 alarm',
  alarm_lvl2MinAlarm: 'Min level 2 alarm',
  alarm_lvl3MinAlarm: 'Min level 3 alarm',
  alarm_off: 'Off',
  alarm_new_maintenance: 'Maintenance request',
  alarm_new_timer: 'Timer alarm',
  alarm_new_lvl: 'Level alarm',
  alarm_new_extcons: 'Ext.Cons. alarm',
  alarm_new_internalTemp: 'Internal temp. alarm',
  alarm_new_clockKO: 'Clock KO alarm',
  alarm_new_sampleWater: 'Sample water',
  alarm_new_maxDoseTime: 'Max Dosage alarm',
  alarm_new_maintenancePump1: 'Maintenance P1',
  alarm_new_maintenancePump2: 'Maintenance P2',
  alarm_new_urOrMeasure1: 'Measure 1 UR/OR alarm',
  alarm_new_urOrMeasure2: 'Measure 2 UR/OR alarm',
  alarm_new_lvl1: 'Level 1 alarm',
  alarm_new_lvl2: 'Level 2 alarm',
  alarm_new_maxDosageTimeOut1: 'MAX T P1 alarm',
  alarm_new_maxDosageTimeOut2: 'MAX T P2 alarm',
  statuses: 'Status',
  theme: 'theme',
  toolStatus: 'Instrument status',
  minWarningLimit: 'Min ideal value',
  maxWarningLimit: 'Max ideal value',
  canNotSaveOfflineOrErrModule:
    'Settings cannot be saved when the module is offline or a communication error occurs',
  ew2PoolInterfaceName: 'Evolution EW² Pool',
  ew2Pool_pHOrpTcInterfaceName: 'EW² Pool pH/ORP/T',
  ew2Pool_pHCacTcInterfaceName: 'EW² Pool pH/CAC/T',
  ew2Pool_pHCleTcInterfaceName: 'EW² Pool pH/CLE/T',
  nova2Pool_pHOrpTcInterfaceName: 'Nova² Pool pH/ORP/T',
  nova2Pool_pHCacTcInterfaceName: 'Nova² Pool pH/CAC/T',
  nova2Pool_pHCleTcInterfaceName: 'Nova² Pool pH/CLE/T',
  nova2PoolP_pHOrpTcInterfaceName: 'Nova² Pool P pH/ORP/T',
  nova2PoolP_pHCacTcInterfaceName: 'Nova² Pool P pH/CAC/T',
  nova2PoolP_pHCleTcInterfaceName: 'Nova² Pool P pH/CLE/T',
  alarm_minThresholdM1: 'Min threshold pH',
  alarm_maxThresholdM1: 'Max threshold pH',
  alarm_lvl1m1: 'Level 1 pH',
  alarm_lvl2m1: 'Level 2 pH',
  alarm_underRangeM1: 'Under Range pH',
  alarm_overRangeM1: 'Over Range pH',
  alarm_maxDosageM1: 'Maximum dosage pH',
  alarm_minThresholdM2: 'Min threshold Cl',
  alarm_maxThresholdM2: 'Max threshold Cl',
  alarm_lvl1m2: 'Level 1 Cl',
  alarm_lvl2m2: 'Level 2 Cl',
  alarm_minLimitPh: 'Min limit pH',
  alarm_maxLimitPh: 'Max limit pH',
  alarm_lvlPh: 'Level pH',
  alarm_minLimitCl: 'Min limit Cl',
  alarm_maxLimitCl: 'Max limit Cl',
  alarm_lvlCl: 'Level Cl',
  alarm_underRangeM2: 'Under Range Cl',
  alarm_overRangeM2: 'Over Range Cl',
  alarm_maxDosageM2: 'Maximum dosage Cl',
  alarm_sampleFlow: 'Sample Water flow',
  alarm_pHPriority: 'pH priority',
  output_pfmM1: 'OUT PFM pH',
  output_pfmM2: 'OUT PFM Cl',
  output_outM1: 'OUT pH',
  output_flocculant: 'OUT FLOCCULANT',
  output_outM2: 'OUT Cl',
  output_antiAlgae: 'OUT ANTI-ALGAE',
  output_poolRelayAlarm: 'ALARM RELAY',
  input_lvl1m1: 'IN Level 1 pH',
  input_lvl2m1: 'IN Level 2 pH',
  input_externalConsent: 'IN Ext. Consent',
  input_ecoMode: 'IN Eco Mode',
  input_sampleWater: 'IN Sample Water',
  input_lvl1m2: 'IN Level 1 Cl',
  input_lvl2m2: 'IN Level 2 Cl',
  setpointM1OnOffParamDesc: 'Setpoint pH On/Off',
  propBandM1OnOffParamDesc: 'Hysteresis pH On/Off',
  dosageDirM1OnOffParamDesc: 'Dosage direction pH On/Off',
  maxDosageTimeM1OnOffParamDesc: 'MAX Dosage Time pH On/Off',
  setpointM1PwmParamDesc: 'Setpoint M1 PWM',
  propBandM1PwmParamDesc: 'Proportional band pH PWM',
  dosageDirM1PwmParamDesc: 'Dosage direction pH PWM',
  maxDosageTimeM1PwmParamDesc: 'MAX Dosage Time pH PWM',
  setpointM2OnOffParamDesc: 'Setpoint Cl On/Off',
  setpointM2PwmParamDesc: 'Setpoint Cl PWM',
  setpointM1PfmParamDesc: 'Setpoint pH PFM',
  propBandM1PfmParamDesc: 'Proportional band pH PFM',
  dosageDirM1PfmParamDesc: 'Dosage direction pH PFM',
  maxDosageTimeM1PfmParamDesc: 'MAX Dosage Time pH PFM',
  minFreqM1ParamDesc: 'Min frequency pH',
  maxFreqM1ParamDesc: 'Max frequency pH',
  minLimitM1ParamDesc: 'Limit MIN pH',
  maxLimitM1ParamDesc: 'Limit MAX pH',
  propBandM2OnOffParamDesc: 'Hysteresis Cl On/Off',
  dosageDirM2OnOffParamDesc: 'Dosage direction Cl On/Off',
  maxDosageTimeM2OnOffParamDesc: 'MAX Dosage Time Cl On/Off',
  propBandM2PwmParamDesc: 'Proportional band Cl PWM',
  dosageDirM2PwmParamDesc: 'Dosage direction Cl PWM',
  maxDosageTimeM2PwmParamDesc: 'MAX Dosage Time Cl PWM',
  setpointM2PfmParamDesc: 'Setpoint Cl PFM',
  propBandM2PfmParamDesc: 'Proportional band Cl PFM',
  dosageDirM2PfmParamDesc: 'Dosage direction Cl PFM',
  maxDosageTimeM2PfmParamDesc: 'MAX Dosage Time Cl PFM',
  minFreqM2ParamDesc: 'Min frequency Cl',
  maxFreqM2ParamDesc: 'Max frequency Cl',
  setpointEcoModeParamDesc: 'Setpoint Eco/Boost Mode',
  udmTempParamDesc: 'UDM Temperature',
  maxLimitM2ParamDesc: 'Limit MAX Cl',
  minLimitM2ParamDesc: 'Limit MIN Cl',
  acidification: 'Acidification',
  alkalization: 'Alkalization',
  dechlorination: 'Dechlorination',
  chlorination: 'Chlorination',
  output_out230VM2: 'OUT_230V Cl',
  output_out230VM1: 'OUT_230V pH',
  output_phMagnet: 'Magnet status pH',
  output_clMagnet: 'Magnet status Cl',
  output_phOutputStatus: 'Output status pH',
  output_clOutputStatus: 'Output status Cl',
  admin2: 'Distributor',
  referent: 'Referent',
  externalConsent: 'External consent',
  ecoMode: 'Eco-Mode',
  companyName: 'Company name',
  invalidNameOrCompanyName: 'Set a name/surname or company name',
  alarm_sampleFlowM1: 'flusso campione M1',
  alarm_sampleFlowM2: 'flusso campione M2',
  output_out1M1: 'OUT1 M2', // STEIEL-161 OUT1 M1
  output_out2M1: 'OUT2 M2', // STEIEL-161 OUT2 M1
  output_out1M2: 'OUT1 M1', // STEIEL-161 OUT1 M2
  output_out2M2: 'OUT2 M1', // STEIEL-161 OUT2 M2
  output_pfm1M1: 'PFM1 M1',
  output_pfm2M1: 'PFM2 M1',
  output_pfm1M2: 'PFM1 M2',
  output_pfm2M2: 'PFM2 M2',
  input_sampleWaterM2: 'Samplewater M2',
  ew2InterfaceName: 'EW²',
  input_ew2_lvl1m1: 'Livello 1 M1',
  input_ew2_lvl2m1: 'Livello 2 M1',
  input_ew2_externalConsent: 'Abilitazione esterna',
  input_ew2_ecoMode: 'Self-cleaning',
  input_ew2_sampleWater: 'Samplewater M1',
  input_ew2_sampleWaterM2: 'Samplewater M2',
  input_ew2_lvl1m2: 'Livello 1 M2',
  input_ew2_lvl2m2: 'Livello 2 M2',
  input_waterMeter: 'Water meter',
  alarm_ew2_minThresholdM1: 'soglia minima M1',
  alarm_ew2_maxThresholdM1: 'soglia massima M1',
  alarm_ew2_lvl1m1: 'level 1 M1',
  alarm_ew2_lvl2m1: 'level 2 M1',
  alarm_ew2_underRangeM1: 'under range M1',
  alarm_ew2_overRangeM1: 'over range M1',
  alarm_ew2_maxDosageM1: 'massimo dosaggio M1',
  alarm_ew2_sampleFlowM1: 'flusso campione M1',
  alarm_ew2_minThresholdM2: 'soglia minima M2',
  alarm_ew2_maxThresholdM2: 'soglia massima M2',
  alarm_ew2_lvl1m2: 'level 1 M2',
  alarm_ew2_lvl2m2: 'level 2 M2',
  alarm_ew2_underRangeM2: 'under range M2',
  alarm_ew2_overRangeM2: 'over range M2',
  alarm_ew2_maxDosageM2: 'massimo dosaggio M2',
  alarm_ew2_sampleFlowM2: 'flusso campione M2',
  P01EW2ParamDesc: 'Config. OUT1 M1',
  P02EW2ParamDesc: 'Setpoint OUT1 OnOff M1',
  P03EW2ParamDesc: 'Setpoint OUT1 PWM M1',
  P04EW2ParamDesc: 'Int. Lavoro OUT1 Soglia1 M1',
  P05EW2ParamDesc: 'Int. Lavoro OUT1 Soglia2 M1',
  P06EW2ParamDesc: 'Config. OUT2 M1',
  P07EW2ParamDesc: 'Setpoint OUT2 OnOff M1',
  P08EW2ParamDesc: 'Setpoint OUT2 PWM M1',
  P09EW2ParamDesc: 'Int. Lavoro OUT2 Soglia1 M1',
  P10EW2ParamDesc: 'Int. Lavoro OUT2 Soglia2 M1',
  P11EW2ParamDesc: 'Config. OUT3 M1',
  P12EW2ParamDesc: 'Setpoint OUT3 PFM M1',
  P13EW2ParamDesc: 'Frequenza min OUT3 M1',
  P14EW2ParamDesc: 'Frequenza max OUT3 M1',
  P15EW2ParamDesc: 'Config. OUT4 M1',
  P16EW2ParamDesc: 'Setpoint OUT4 PFM M1',
  P17EW2ParamDesc: 'Frequenza min OUT4 M1',
  P18EW2ParamDesc: 'Frequenza max OUT4 M1',
  P19EW2ParamDesc: 'Config. OUT-mA M1',
  P20aEW2ParamDesc: 'Scala OUT-mA M1',
  P20bEW2ParamDesc: 'Scala OUT-mA M1',
  P21EW2ParamDesc: 'Setpoint OUT-mA M1 (Reg.)',
  P22EW2ParamDesc: 'Limite min M1 ',
  P23EW2ParamDesc: 'Limite max M1 ',
  P24EW2ParamDesc: 'Setpoint Eco/Boost mode OUT1 M1',
  P25EW2ParamDesc: 'Setpoint Eco/Boost mode OUT2 M1',
  P26EW2ParamDesc: 'Setpoint Eco/Boost mode OUT-mA M1',
  P27EW2ParamDesc: 'Config. OUT1 M2',
  P28EW2ParamDesc: 'Setpoint OUT1 OnOff M2',
  P29EW2ParamDesc: 'Setpoint OUT1 PWM M2',
  P30EW2ParamDesc: 'Int. Lavoro OUT1 Soglia1 M2',
  P31EW2ParamDesc: 'Int. Lavoro OUT1 Soglia2 M2',
  P32EW2ParamDesc: 'Config. OUT2 M2',
  P33EW2ParamDesc: 'Setpoint OUT2 OnOff M2',
  P34EW2ParamDesc: 'Setpoint OUT2 PWM M2',
  P35EW2ParamDesc: 'Int. Lavoro OUT2 Soglia1 M2',
  P36EW2ParamDesc: 'Int. Lavoro OUT2 Soglia2 M2',
  P37EW2ParamDesc: 'Config. OUT3 M2',
  P38EW2ParamDesc: 'Setpoint OUT3 PFM M2',
  P39EW2ParamDesc: 'Frequenza min OUT3 M2',
  P40EW2ParamDesc: 'Frequenza max OUT3 M2',
  P41EW2ParamDesc: 'Config. OUT4 M2',
  P42EW2ParamDesc: 'Setpoint OUT4 PFM M2',
  P43EW2ParamDesc: 'Frequenza min OUT4 M2',
  P44EW2ParamDesc: 'Frequenza max OUT4 M2',
  P45EW2ParamDesc: 'Config. OUT-mA M2',
  P46aEW2ParamDesc: 'Scala OUT-mA M2',
  P46bEW2ParamDesc: 'Scala OUT-mA M2',
  P47EW2ParamDesc: 'Setpoint OUT-mA M2 (Reg.)',
  P48EW2ParamDesc: 'Limite min M2',
  P49EW2ParamDesc: 'Limite max M2',
  P50EW2ParamDesc: 'Setpoint Eco/Boost mode OUT1 M2',
  P51EW2ParamDesc: 'Setpoint Eco/Boost mode OUT2 M2',
  P52EW2ParamDesc: 'Setpoint Eco/Boost mode OUT-mA M2',
  P53EW2ParamDesc: 'Isteresi OUT1 OnOff M1',
  P54EW2ParamDesc: 'Banda Proporzionale OUT1 PWM M1',
  P55EW2ParamDesc: 'Direzione Dosaggio OUT1 OnOff M1',
  P56EW2ParamDesc: 'Direzione Dosaggio OUT1 PWM M1',
  P57EW2ParamDesc: 'Tempo MAX Dosaggio OUT1 OnOff M1',
  P58EW2ParamDesc: 'Tempo MAX Dosaggio OUT1 PWM M1',
  P59EW2ParamDesc: 'Stato tra le soglie OUT1 (Int. lavoro) M1',
  P60EW2ParamDesc: 'Isteresi OUT2 OnOff M1',
  P61EW2ParamDesc: 'Banda Proporzionale OUT2 PWM M1',
  P62EW2ParamDesc: 'Direzione Dosaggio OUT2 OnOff M1',
  P63EW2ParamDesc: 'Direzione Dosaggio OUT2 PWM M1',
  P64EW2ParamDesc: 'Tempo MAX Dosaggio OUT2 OnOff M1',
  P65EW2ParamDesc: 'Tempo MAX Dosaggio OUT2 PWM M1',
  P66EW2ParamDesc: 'Stato tra le soglie OUT2 (Int. lavoro) M1',
  P67EW2ParamDesc: 'Banda Proporzionale OUT3 PFM M1',
  P68EW2ParamDesc: 'Direzione Dosaggio OUT3 PFM M1',
  P69EW2ParamDesc: 'Tempo MAX Dosaggio OUT3 PFM M1',
  P70EW2ParamDesc: 'Banda Proporzionale OUT4 PFM M1',
  P71EW2ParamDesc: 'Direzione Dosaggio OUT4 PFM M1',
  P72EW2ParamDesc: 'Tempo MAX Dosaggio OUT4 PFM M1',
  P73EW2ParamDesc: 'Valore 0/4 mA OUT-mA M1',
  P74EW2ParamDesc: 'Valore 20 mA OUT-mA M1',
  P75EW2ParamDesc: 'Banda Proporzionale OUT-mA M1',
  P76EW2ParamDesc: 'Direzione Dosaggio OUT-mA M1',
  P77EW2ParamDesc: 'Tempo MAX Dosaggio OUT-mA M1',
  P78EW2ParamDesc: 'Isteresi OUT1 OnOff M2',
  P79EW2ParamDesc: 'Banda Proporzionale OUT1 PWM M2',
  P80EW2ParamDesc: 'Direzione Dosaggio OUT1 OnOff M2',
  P81EW2ParamDesc: 'Direzione Dosaggio OUT1 PWM M2',
  P82EW2ParamDesc: 'Tempo MAX Dosaggio OUT1 OnOff M2',
  P83EW2ParamDesc: 'Tempo MAX Dosaggio OUT1 PWM M2',
  P84EW2ParamDesc: 'Stato tra le soglie OUT1 (Int. lavoro) M2',
  P85EW2ParamDesc: 'Isteresi OUT2 OnOff M2',
  P86EW2ParamDesc: 'Banda Proporzionale OUT2 pwm M2',
  P87EW2ParamDesc: 'Direzione Dosaggio OUT2 OnOff M2',
  P88EW2ParamDesc: 'Direzione Dosaggio OUT2 PWM M2',
  P89EW2ParamDesc: 'Tempo MAX Dosaggio OUT2 OnOff M2',
  P90EW2ParamDesc: 'Tempo MAX Dosaggio OUT2 PWM M2',
  P91EW2ParamDesc: 'Stato tra le soglie OUT2 (Int. lavoro) M2',
  P92EW2ParamDesc: 'Banda Proporzionale OUT3 PFM M2',
  P93EW2ParamDesc: 'Direzione Dosaggio OUT3 PFM M2',
  P94EW2ParamDesc: 'Tempo MAX Dosaggio OUT3 PFM M2',
  P95EW2ParamDesc: 'Banda Proporzionale OUT4 PFM M2',
  P96EW2ParamDesc: 'Direzione Dosaggio OUT4 PFM M2',
  P97EW2ParamDesc: 'Tempo MAX Dosaggio OUT4 PFM M2',
  P98EW2ParamDesc: 'Valore 0/4 mA OUT-mA M2',
  P99EW2ParamDesc: 'Valore 20 mA OUT-mA M2',
  P100EW2ParamDesc: 'Banda Proporzionale OUT-mA M2',
  P101EW2ParamDesc: 'Direzione Dosaggio OUT-mA M2',
  P102EW2ParamDesc: 'Tempo MAX Dosaggio OUT-mA M2',
  repetition: 'ripetizione',
  regulation: 'regulation',
  acidificationDechlorinationReduction: 'Acidificazione/Declorazione/Riduzione',
  alkalizationChlorinationOxidation: 'Alcalinizzazione/Clorazione/Ossidazione',
  workInt: 'Int. di lavoro',
  ewInterfaceName: 'EW',
  input_ew_lvl1m1: 'Livello 1 M1',
  input_ew_lvl2m1: 'Livello 2 M1',
  input_ew_externalConsent: 'Abilitazione esterna',
  input_ew_ecoMode: 'Eco/boost mode',
  input_ew_sampleWater: 'Samplewater M1',
  input_ew_autoClean: 'Self-cleaning',
  alarm_ew_minThresholdM1: 'soglia minima M1',
  alarm_ew_maxThresholdM1: 'soglia massima M1',
  alarm_ew_lvl1m1: 'level 1 M1',
  alarm_ew_lvl2m1: 'level 2 M1',
  alarm_ew_underRangeM1: 'under range M1',
  alarm_ew_overRangeM1: 'over range M1',
  alarm_ew_maxDosageM1: 'massimo dosaggio M1',
  alarm_ew_sampleFlowM1: 'flusso campione M1',
  P01EWParamDesc: 'Config. OUT1',
  P02EWParamDesc: 'Setpoint OUT1 OnOff',
  P03EWParamDesc: 'Setpoint OUT1 PWM',
  P04EWParamDesc: 'Int. Lavoro OUT1 Soglia1',
  P05EWParamDesc: 'Int. Lavoro OUT1 Soglia2',
  P06EWParamDesc: 'Config. OUT2',
  P07EWParamDesc: 'Setpoint OUT2 OnOff',
  P08EWParamDesc: 'Setpoint OUT2 PWM',
  P09EWParamDesc: 'Int. Lavoro OUT2 Soglia1',
  P10EWParamDesc: 'Int. Lavoro OUT2 Soglia2',
  P11EWParamDesc: 'Config. OUT3',
  P12EWParamDesc: 'Setpoint OUT3 PFM',
  P13EWParamDesc: 'Frequenza min OUT3',
  P14EWParamDesc: 'Frequenza max OUT3',
  P15EWParamDesc: 'Config. OUT4',
  P16EWParamDesc: 'Setpoint OUT4 PFM',
  P17EWParamDesc: 'Frequenza min OUT4',
  P18EWParamDesc: 'Frequenza max OUT4',
  P19EWParamDesc: 'Config. OUT-mA',
  P20aEWParamDesc: 'Scala OUT-mA',
  P20bEWParamDesc: 'Scala OUT-mA',
  P21EWParamDesc: 'Setpoint OUT-mA (Reg.)',
  P22EWParamDesc: 'Limite min',
  P23EWParamDesc: 'Limite max',
  P24EWParamDesc: 'Setpoint Eco/Boost mode OUT1',
  P25EWParamDesc: 'Setpoint Eco/Boost mode OUT2',
  P26EWParamDesc: 'Setpoint Eco/Boost mode OUT-mA',
  P27EWParamDesc: 'Isteresi OUT1 OnOff',
  P28EWParamDesc: 'Banda Proporzionale OUT1 PWM',
  P29EWParamDesc: 'Direzione Dosaggio OUT1 OnOff',
  P30EWParamDesc: 'Direzione Dosaggio OUT1 PWM',
  P31EWParamDesc: 'Tempo MAX Dosaggio OUT1 OnOff',
  P32EWParamDesc: 'Tempo MAX Dosaggio OUT1 PWM',
  P33EWParamDesc: 'Stato tra le soglie OUT1 (Int. lavoro)',
  P34EWParamDesc: 'Isteresi OUT2 OnOff',
  P35EWParamDesc: 'Banda Proporzionale OUT2 PWM',
  P36EWParamDesc: 'Direzione Dosaggio OUT2 OnOff',
  P37EWParamDesc: 'Direzione Dosaggio OUT2 PWM',
  P38EWParamDesc: 'Tempo MAX Dosaggio OUT2 OnOff',
  P39EWParamDesc: 'Tempo MAX Dosaggio OUT2 PWM',
  P40EWParamDesc: 'Stato tra le soglie OUT2 (Int. lavoro)',
  P41EWParamDesc: 'Banda Proporzionale OUT3 PFM',
  P42EWParamDesc: 'Direzione Dosaggio OUT3 PFM',
  P43EWParamDesc: 'Tempo MAX Dosaggio OUT3 PFM',
  P44EWParamDesc: 'Banda Proporzionale OUT4 PFM',
  P45EWParamDesc: 'Direzione Dosaggio OUT4 PFM',
  P46EWParamDesc: 'Tempo MAX Dosaggio OUT4 PFM',
  P47EWParamDesc: 'Valore 0/4 mA OUT-mA',
  P48EWParamDesc: 'Valore 20 mA OUT',
  P49EWParamDesc: 'Banda Proporzionale OUT-mA',
  P50EWParamDesc: 'Direzione Dosaggio OUT-mA',
  P51EWParamDesc: 'Tempo MAX Dosaggio OUT-mA',
  alertNumberDecimals1:
    'Attention! The number of decimals setting must match the resolution displayed in the instrument.',
  alertNumberDecimals2: 'It is essential to follow this indication to avoid system malfunctions.',
  selfCleaning: 'Self-cleaning',
  userHierarchy: 'User hierarchy',
  orgChartYou: 'You',
  orgChartResetView: 'Reset view',
  orgChartCenterOnUser: 'Center on current user',
  orgChartShowAll: 'Show all',
  userHierarchyList: 'User hierarchy (list)',
  hierarchyNoLinkedUsers: 'No linked users.',
  hierarchyNavigateUp: 'Up one level',
  hierarchyRoleUnknown: 'Role not set',
  instrumentName: 'instrument name',
  P34Nova2PoolPParamDesc: 'Config. Pump pH',
  P35Nova2PoolPParamDesc: 'Config. Pump Cl',
  hthEw2PoolMachineTypeAltName: 'CYCL’EAU EW²Pool DIVERSEY',
};
